import Vue from 'vue'
export const EventBus = new Vue({
    data: {
        // year: new Date().getFullYear()
        year: 2019
    },
})